/* eslint-disable */

import Login from "components/features/login/Login";

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
